import { render, staticRenderFns } from "./CreateNewDesktop.vue?vue&type=template&id=dc7849ce&"
import script from "./CreateNewDesktop.vue?vue&type=script&lang=js&"
export * from "./CreateNewDesktop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports